<template>
  <div class="step-header">
    <div class="step-progress-row">
      <span class="step-progress-label">Paso {{ step }} de {{ total }} · {{ name }}</span>
      <span v-if="context" class="step-vehicle-context">{{ context }}</span>
    </div>
    <div
      class="step-progress-track"
      role="progressbar"
      :aria-label="`Paso ${step} de ${total}`"
      aria-valuemin="0"
      aria-valuemax="100"
      :aria-valuenow="percent"
    >
      <div class="step-progress-fill" :style="{ width: `${percent}%` }"></div>
    </div>
    <h2 class="widget-title-compact">{{ title }}</h2>
    <p class="step-subtitle">{{ subtitle }}</p>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps<{
  step: number;
  total: number;
  name: string;
  title: string;
  subtitle: string;
  /** Optional right-aligned context, e.g. the selected vehicle. */
  context?: string;
}>();

const percent = computed(() => Math.floor((props.step / props.total) * 100));
</script>

<style scoped>
.step-header {
  display: flex;
  flex-direction: column;
  margin-bottom: 28px;
}

.step-progress-row {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 12px;
  margin-bottom: 10px;
}

.step-progress-label {
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.02em;
  color: var(--ui-label);
}

.step-vehicle-context {
  font-size: 12px;
  color: var(--ui-label);
  text-align: right;
}

.step-progress-track {
  height: 2px;
  border-radius: 2px;
  background: var(--ui-bg-disabled);
  margin-bottom: 28px;
}

.step-progress-fill {
  height: 100%;
  border-radius: 2px;
  background: var(--ui-accent);
  transition: width 0.4s ease;
}

.widget-title-compact {
  margin: 0 0 6px;
  font-size: 24px;
  font-weight: 600;
  letter-spacing: -0.01em;
  color: var(--ui-text-strong);
  text-align: left;
}

.step-subtitle {
  margin: 0;
  font-size: 14px;
  color: var(--ui-label);
}
</style>
